import React from 'react';
import { observer } from 'owa-mobx-react';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Panel from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Drawer from '@fluentui/react-components' instead. */
import { Panel, PanelType, type IPanelStyles } from '@fluentui/react/lib/Panel';
import FolderPaneContainer from './FolderPaneContainer';
import {
    setShowFolderPane,
    shouldShowFolderPane,
    shouldShowFolderPaneOverlayAsBlocking,
} from 'owa-mail-layout';
import { getPalette } from 'owa-theme';
import { isShySuiteHeaderMode } from 'owa-suite-header-store';
import { APP_BAR_STATIC_WIDTH, APP_BAR_WITH_LABELS_STATIC_WIDTH } from 'owa-layout';
import { type StateChangeSource } from 'owa-left-pane-layout/lib/types/StateChangeSource';
import { customScrollBarOnHover } from 'owa-global-styles';
import { getOptionsForFeature, OwsOptionsFeatureType } from 'owa-outlook-service-option-store';
import type { AppBarDisplayModeOptions } from 'owa-outlook-service-option-store';
import classNames from 'owa-classnames';
import {
    overlayLeftPane,
    overlayLeftPaneMain,
    overlayLeftPaneWithAppNames,
    isShyHeaderMode as shyModeMain,
    overlayLeftPaneScrollableContent,
} from './MailLeftPaneAsOverlay.scss';

const leftRailWidth = 48;
const overlayLeftRailWidth = 280;

const folderPaneOverlayWidth = overlayLeftRailWidth - leftRailWidth;

const panelOverlayProps = {
    isDarkThemed: false,
};

const focusTrapZoneProps = {
    forceFocusInsideTrap: false,
    isClickableOutsideFocusTrap: true,
};

const defaultExport: React.FunctionComponent = observer(function MailLeftPaneAsOverlay() {
    const palette = getPalette();
    const isShyHeader = isShySuiteHeaderMode();
    const isAppNameLabelsEnabled = getOptionsForFeature<AppBarDisplayModeOptions>(
        OwsOptionsFeatureType.AppBarDisplayMode
    )?.labelsEnabled;
    const overlayLeftPanePanelStyles = React.useMemo((): Partial<IPanelStyles> => {
        const folderPaneOverlayWidthString = `${folderPaneOverlayWidth}px`;

        return {
            main: [
                overlayLeftPaneMain,
                isShyHeader && shyModeMain,
                {
                    width: folderPaneOverlayWidthString,
                    // We need to move the panel 'underneath' the hamburger button since it's above the folder pane if it the OfficeRail rail is on
                    left:
                        '-' +
                        (isAppNameLabelsEnabled
                            ? APP_BAR_WITH_LABELS_STATIC_WIDTH
                            : APP_BAR_STATIC_WIDTH),
                },
            ],
            content: {
                width: folderPaneOverlayWidthString,
                padding: 0,
            },
            contentInner: {
                background: palette.neutralLighter,
            },
            commands: {
                margin: 0,
                paddingTop: 0,
            },
            scrollableContent: [overlayLeftPaneScrollableContent, customScrollBarOnHover],
        };
    }, [palette.neutralLighter, isShyHeader]);

    return (
        <Panel
            className={
                isAppNameLabelsEnabled
                    ? classNames(overlayLeftPaneWithAppNames, overlayLeftPane)
                    : overlayLeftPane
            }
            styles={overlayLeftPanePanelStyles}
            isLightDismiss={true}
            isOpen={shouldShowFolderPane()}
            hasCloseButton={false}
            overlayProps={panelOverlayProps}
            onOuterClick={onOuterClick}
            focusTrapZoneProps={focusTrapZoneProps}
            onDismiss={onDismissFolderPaneOverlay}
            type={PanelType.smallFixedNear}
            isBlocking={!shouldShowFolderPaneOverlayAsBlocking()}
        >
            <FolderPaneContainer />
        </Panel>
    );
}, 'MailLeftPaneAsOverlay');
export default defaultExport;

function onOuterClick() {
    // Need stub implemetation of onOuterClick to ensure this function is called instead of onDismiss
    // for the cases where the user clicks in the left rail area. Prevents the bug where a user clicks
    // the hamburger button and the pane collapses and immediately re expands.
    return;
}

function onDismissFolderPaneOverlay() {
    setShowFolderPane(false, 0, false);
}
